export default __webpack_public_path__ + "static/media/edit.20607313.svg";